/**
 * Text serialisation for mapper configs. The bridge stores structured JSON; YAML only
 * exists as an editing and reading affordance in the code editor and the builder preview.
 */
import yaml from 'js-yaml';

export function stringifyMapperConfig(value, mode) {
  if (mode === 'yaml') {
    return yaml.dump(value || {}, { noRefs: true, lineWidth: 120 }).trimEnd();
  }
  return JSON.stringify(value || {}, null, 2);
}

export function parseMapperConfig(text, mode) {
  if (!text.trim()) {
    return undefined;
  }
  return mode === 'yaml' ? yaml.load(text) : JSON.parse(text);
}
